"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promoNudgeSucceeded = exports.promoNudgeFailed = exports.getPromoNudgeConfig = exports.paymentFailed = exports.orderSucceeded = exports.orderFailed = exports.placeOrder = exports.fetchInitialPaymentConfigData = exports.fetchBrandConfigError = exports.sessionCreationFailed = exports.initiateConfigRequestFailed = exports.retrievedInitiateConfigData = exports.fetchFaceplateGroupsError = exports.retrievedFaceplateGroups = exports.fetchFaceplateGroups = exports.fetchBannerConfigError = exports.retrievedBannerConfig = exports.fetchBannerConfig = exports.fetchBrandConfig = exports.retrievedBrandConfigActions = exports.createCapiSession = exports.clearCapiSession = exports.setCapiSession = exports.setCapiConfig = exports.PROMO_NUDGE_SUCCESS = exports.PROMO_NUDGE_FAILED = exports.GET_PROMO_NUDGE_CONFIG_DATA = exports.PAYMENT_FAILED = exports.ORDER_SUCCESS = exports.ORDER_FAILED = exports.PLACE_ORDER = exports.RETRIEVED_BRAND_CONFIG = exports.SESSION_CREATION_ERROR = exports.RETRIEVED_BANNER_CONFIG = exports.FETCH_BRAND_CONFIG_ERROR = exports.RETRIEVED_FACEPLATE_GROUPS = exports.FETCH_FACEPLATE_GROUPS_ERROR = exports.FETCH_FACEPLATE_GROUPS = exports.FETCH_BANNER_CONFIG_ERROR = exports.FETCH_BANNER_CONFIG = exports.FETCH_BRAND_CONFIG = exports.SET_CAPI_SESSION = exports.CREATE_CAPI_SESSION = exports.CLEAR_CAPI_SESSION = exports.REQUEST_INITIATE_CONFIG_ERROR = exports.RETRIEVED_INITIATE_CONFIG_DATA = exports.GET_INITIAL_PAYMENT_CONFIG_DATA = exports.SET_CAPI_CONFIG = void 0;

var _requests = require("../requests");

/**
 * Action types
 */
// Configuration
var SET_CAPI_CONFIG = 'capi/SET_CAPI_CONFIG';
exports.SET_CAPI_CONFIG = SET_CAPI_CONFIG;
var GET_INITIAL_PAYMENT_CONFIG_DATA = 'capi/GET_INITIAL_PAYMENT_CONFIG_DATA';
exports.GET_INITIAL_PAYMENT_CONFIG_DATA = GET_INITIAL_PAYMENT_CONFIG_DATA;
var RETRIEVED_INITIATE_CONFIG_DATA = 'capi/RETRIEVED_INITIATE_CONFIG_DATA';
exports.RETRIEVED_INITIATE_CONFIG_DATA = RETRIEVED_INITIATE_CONFIG_DATA;
var REQUEST_INITIATE_CONFIG_ERROR = 'capi/REQUEST_INITIATE_CONFIG_ERROR'; // Session

exports.REQUEST_INITIATE_CONFIG_ERROR = REQUEST_INITIATE_CONFIG_ERROR;
var CLEAR_CAPI_SESSION = 'capi/CLEAR_CAPI_SESSION';
exports.CLEAR_CAPI_SESSION = CLEAR_CAPI_SESSION;
var CREATE_CAPI_SESSION = 'capi/CREATE_CAPI_SESSION';
exports.CREATE_CAPI_SESSION = CREATE_CAPI_SESSION;
var SET_CAPI_SESSION = 'capi/SET_CAPI_SESSION'; // Brand config

exports.SET_CAPI_SESSION = SET_CAPI_SESSION;
var FETCH_BRAND_CONFIG = 'capi/FETCH_BRAND_CONFIG';
exports.FETCH_BRAND_CONFIG = FETCH_BRAND_CONFIG;
var FETCH_BANNER_CONFIG = 'capi/FETCH_BANNER_CONFIG';
exports.FETCH_BANNER_CONFIG = FETCH_BANNER_CONFIG;
var FETCH_BANNER_CONFIG_ERROR = 'capi/FETCH_BANNER_CONFIG_ERROR';
exports.FETCH_BANNER_CONFIG_ERROR = FETCH_BANNER_CONFIG_ERROR;
var FETCH_FACEPLATE_GROUPS = 'capi/FETCH_FACEPLATE_GROUPS';
exports.FETCH_FACEPLATE_GROUPS = FETCH_FACEPLATE_GROUPS;
var FETCH_FACEPLATE_GROUPS_ERROR = 'capi/FETCH_FACEPLATE_GROUPS_ERROR';
exports.FETCH_FACEPLATE_GROUPS_ERROR = FETCH_FACEPLATE_GROUPS_ERROR;
var RETRIEVED_FACEPLATE_GROUPS = 'capi/RETRIEVED_FACEPLATE_GROUPS';
exports.RETRIEVED_FACEPLATE_GROUPS = RETRIEVED_FACEPLATE_GROUPS;
var FETCH_BRAND_CONFIG_ERROR = 'capi/FETCH_BRAND_CONFIG_ERROR';
exports.FETCH_BRAND_CONFIG_ERROR = FETCH_BRAND_CONFIG_ERROR;
var RETRIEVED_BANNER_CONFIG = 'capi/RETRIEVED_BANNER_CONFIG';
exports.RETRIEVED_BANNER_CONFIG = RETRIEVED_BANNER_CONFIG;
var SESSION_CREATION_ERROR = 'capi/SESSION_CREATION_ERROR';
exports.SESSION_CREATION_ERROR = SESSION_CREATION_ERROR;
var RETRIEVED_BRAND_CONFIG = {
  PREFERENCES: 'capi/RETRIEVED_BRAND_CONFIG/PREFERENCES',
  CATALOG: 'capi/RETRIEVED_BRAND_CONFIG/CATALOG',
  PAYMENT: 'capi/RETRIEVED_BRAND_CONFIG/PAYMENT',
  SHIPPING: 'capi/RETRIEVED_BRAND_CONFIG/SHIPPING',
  FEATURES: 'capi/RETRIEVED_BRAND_CONFIG/FEATURES',
  PROGRAMS: 'capi/RETRIEVED_BRAND_CONFIG/PROGRAMS',
  META: 'capi/RETRIEVED_BRAND_CONFIG/META',
  BALANCE: 'capi/RETRIEVED_BRAND_CONFIG/BALANCE',
  ACCESSORIES: 'capi/RETRIEVED_BRAND_CONFIG/ACCESSORIES',
  LIMITS: 'capi/RETRIEVED_BRAND_CONFIG/LIMITS'
}; // Ordering

exports.RETRIEVED_BRAND_CONFIG = RETRIEVED_BRAND_CONFIG;
var PLACE_ORDER = 'capi/PLACE_ORDER';
exports.PLACE_ORDER = PLACE_ORDER;
var ORDER_FAILED = 'capi/ORDER_FAILED';
exports.ORDER_FAILED = ORDER_FAILED;
var ORDER_SUCCESS = 'capi/ORDER_SUCCESS';
exports.ORDER_SUCCESS = ORDER_SUCCESS;
var PAYMENT_FAILED = 'capi/PAYMENT_FAILED'; // Promo Nudge

exports.PAYMENT_FAILED = PAYMENT_FAILED;
var GET_PROMO_NUDGE_CONFIG_DATA = 'capi/GET_PROMO_NUDGE_CONFIG_DATA';
exports.GET_PROMO_NUDGE_CONFIG_DATA = GET_PROMO_NUDGE_CONFIG_DATA;
var PROMO_NUDGE_FAILED = 'capi/PROMO_NUDGE_FAILED';
exports.PROMO_NUDGE_FAILED = PROMO_NUDGE_FAILED;
var PROMO_NUDGE_SUCCESS = 'capi/PROMO_NUDGE_SUCCESS'; // Action creators
// Brand config

/**
 * Set the CAPI configuration information needed for calling CAPI.
 * @param {string} url - The base URL to find CAPI, ex: https://capi.cashstar.com/
 * @param {string} token - The Brand-specific ordering token used for authentication with CAPI
 */

exports.PROMO_NUDGE_SUCCESS = PROMO_NUDGE_SUCCESS;

var setCapiConfig = function setCapiConfig(url, token) {
  return {
    type: SET_CAPI_CONFIG,
    url: url,
    token: token
  };
};
/**
 * Set the CAPI session ID
 *
 * @param {string} sessionId - The session ID to set
 */


exports.setCapiConfig = setCapiConfig;

var setCapiSession = function setCapiSession(sessionId) {
  return {
    type: SET_CAPI_SESSION,
    id: sessionId
  };
};
/**
 * Clear any current CAPI session
 *
 * Once an order has been placed, this action will be fired to prevent
 * future orders from reusing a spent session.
 */


exports.setCapiSession = setCapiSession;

var clearCapiSession = function clearCapiSession() {
  return {
    type: CLEAR_CAPI_SESSION
  };
};
/**
 * A safer substring function
 *
 * Attempt to substring a provided string using the provided limit as our offset,
 * returning the string itself if the string is not longer than the limit and an
 * empty string if the passed-in value is not a string or is falsy.
 *
 * @param {string} str - the string to operate on
 * @param {Number} lim - the upper limit offset
 * @returns {string} - the substring, full string, or an empty string
 */


exports.clearCapiSession = clearCapiSession;

var subString = function subString(str, lim) {
  if (str && typeof str === 'string') {
    if (str.length > lim) return str.substring(0, lim);
    return str;
  }

  return '';
};
/**
 * Create a new session with CAPI
 *
 * Provides info to CAPI on the user creating the session, and
 * creates a session that we can use to place orders in CAPI with to
 * notify CAPI of the details of the user's session.
 *
 * All parameters are optional, empty strings should be provided for missing values.
 * Parameters are passed as attributes on an object.
 *
 * @param {string} host - The hostname of the site the user is on (ex: gap.cashstar.com)
 * @param {string} refUrl - The HTTP_REFERER header that the user sent along when they visited
 *                      the host, if we have access to one
 * @param {string} ref - The value in a `ref` GET parameter passed in the
 *                      initial request, if present
 * @param {string} promoCode - The value in a `promo_code` GET parameter passed
 *                      in the initial request, if present
 * @param {string} affiliateCode - The value in an `affiliate_id` GET parameter
 *                      passed in the initial request, if present
 * @param {string} sessionKey - A UUID identifying the session
 * @param {string} buyFlow - buyFlow of the user
 * @param {string} pagePath - Pathname of the URL
 */


var createCapiSession = function createCapiSession(_ref) {
  var host = _ref.host,
      refUrl = _ref.refUrl,
      ref = _ref.ref,
      promoCode = _ref.promoCode,
      affiliateCode = _ref.affiliateCode,
      sessionKey = _ref.sessionKey,
      buyFlow = _ref.buyFlow,
      pagePath = _ref.pagePath;
  return {
    type: CREATE_CAPI_SESSION,
    data: {
      host: subString(host, 100),
      refUrl: subString(refUrl, 200),
      ref: subString(ref, 100),
      promoCode: subString(promoCode, 50),
      affiliateCode: subString(affiliateCode, 50),
      buyFlow: subString(buyFlow, 50),
      pagePath: subString(pagePath, 100),
      sessionKey: sessionKey
    }
  };
};
/**
 * Action creators for each of the Brand Config fields. Each accepts a
 * `data` object containing the keys and values associated with the field
 * and returns an action notifying listeners that it has been retrieved.
 */


exports.createCapiSession = createCapiSession;
var retrievedBrandConfigActions = {};
exports.retrievedBrandConfigActions = retrievedBrandConfigActions;
Object.keys(_requests.BRAND_CONFIG_FIELDS).forEach(function (brandConfigField) {
  retrievedBrandConfigActions[_requests.BRAND_CONFIG_FIELDS[brandConfigField]] = function (data) {
    return {
      type: RETRIEVED_BRAND_CONFIG[brandConfigField],
      data: data
    };
  };
});
/**
 * Action to initiate retrieval of the Brand's configuration information.
 * @param {Array} fields - Array of BRAND_CONFIG_FIELDS that should be subset from the Brand's config
 */

var fetchBrandConfig = function fetchBrandConfig() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.values(_requests.BRAND_CONFIG_FIELDS);
  return {
    type: FETCH_BRAND_CONFIG,
    fields: fields
  };
};

exports.fetchBrandConfig = fetchBrandConfig;

var fetchBannerConfig = function fetchBannerConfig() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: FETCH_BANNER_CONFIG,
    data: data
  };
};

exports.fetchBannerConfig = fetchBannerConfig;

var retrievedBannerConfig = function retrievedBannerConfig(data) {
  return {
    type: RETRIEVED_BANNER_CONFIG,
    data: data
  };
};

exports.retrievedBannerConfig = retrievedBannerConfig;

var fetchBannerConfigError = function fetchBannerConfigError(data) {
  return {
    type: FETCH_BANNER_CONFIG_ERROR,
    data: data
  };
};

exports.fetchBannerConfigError = fetchBannerConfigError;

var fetchFaceplateGroups = function fetchFaceplateGroups() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: FETCH_FACEPLATE_GROUPS,
    params: params
  };
};

exports.fetchFaceplateGroups = fetchFaceplateGroups;

var retrievedFaceplateGroups = function retrievedFaceplateGroups(faceplateGroups) {
  return {
    type: RETRIEVED_FACEPLATE_GROUPS,
    faceplateGroups: faceplateGroups
  };
};

exports.retrievedFaceplateGroups = retrievedFaceplateGroups;

var fetchFaceplateGroupsError = function fetchFaceplateGroupsError(error) {
  return {
    type: FETCH_FACEPLATE_GROUPS_ERROR,
    error: error
  };
};

exports.fetchFaceplateGroupsError = fetchFaceplateGroupsError;

var retrievedInitiateConfigData = function retrievedInitiateConfigData(data) {
  return {
    type: RETRIEVED_INITIATE_CONFIG_DATA,
    data: data
  };
};

exports.retrievedInitiateConfigData = retrievedInitiateConfigData;

var initiateConfigRequestFailed = function initiateConfigRequestFailed(error) {
  return {
    type: REQUEST_INITIATE_CONFIG_ERROR,
    error: error
  };
};

exports.initiateConfigRequestFailed = initiateConfigRequestFailed;

var sessionCreationFailed = function sessionCreationFailed(error) {
  return {
    type: SESSION_CREATION_ERROR,
    error: error
  };
};
/**
 * Action to indicate an error has been returned during Brand configuration retrieval.
 * @param {*} error - The error raised
 */


exports.sessionCreationFailed = sessionCreationFailed;

var fetchBrandConfigError = function fetchBrandConfigError(error) {
  return {
    type: FETCH_BRAND_CONFIG_ERROR,
    error: error
  };
};
/**
 * Action to be called before payment widget is loaded.
 * This is essential for payment-js library. It provides us with
 * checkoutId and other data required for loading payment widget.
 */


exports.fetchBrandConfigError = fetchBrandConfigError;

var fetchInitialPaymentConfigData = function fetchInitialPaymentConfigData(data) {
  return {
    type: GET_INITIAL_PAYMENT_CONFIG_DATA,
    data: data
  };
};
/**
 * Action to initiate placing an order with CAPI
 */


exports.fetchInitialPaymentConfigData = fetchInitialPaymentConfigData;

var placeOrder = function placeOrder(order) {
  return {
    type: PLACE_ORDER,
    order: order
  };
};
/**
 * Action to indicate order placement failed due to the order,
 * ex: invalid item amount
 */


exports.placeOrder = placeOrder;

var orderFailed = function orderFailed(error) {
  return {
    type: ORDER_FAILED,
    error: error
  };
};

exports.orderFailed = orderFailed;

var orderSucceeded = function orderSucceeded(data) {
  return {
    type: ORDER_SUCCESS,
    data: data
  };
};
/**
 * Action to indicate order placement failed due to payment,
 * ex: payment info invalid
 */


exports.orderSucceeded = orderSucceeded;

var paymentFailed = function paymentFailed(error) {
  return {
    type: PAYMENT_FAILED,
    error: error
  };
};
/**
 * Get the API configuration information needed for calling Nudge CAPI.
 * @param {string} promoCode - The promo code
 * @param {string} cartAmount - The specified cart amount
 * @param {string} cardAmount - The specified card amount
 */


exports.paymentFailed = paymentFailed;

var getPromoNudgeConfig = function getPromoNudgeConfig(promoCode) {
  var cartAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var cardAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: GET_PROMO_NUDGE_CONFIG_DATA,
    promoCode: promoCode,
    cartAmount: cartAmount,
    cardAmount: cardAmount
  };
};
/**
 * Action to indicate promo nudge failed due to the provide wrong data,
 * ex: invalid promo code
 */


exports.getPromoNudgeConfig = getPromoNudgeConfig;

var promoNudgeFailed = function promoNudgeFailed(error) {
  return {
    type: PROMO_NUDGE_FAILED,
    error: error
  };
};

exports.promoNudgeFailed = promoNudgeFailed;

var promoNudgeSucceeded = function promoNudgeSucceeded(data) {
  return {
    type: PROMO_NUDGE_SUCCESS,
    data: data
  };
};

exports.promoNudgeSucceeded = promoNudgeSucceeded;